import React, { PureComponent } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import _ from "lodash";
import Util from '../../../../Common/util';
import API from '../../../../Common/api';
import { Field, reduxForm } from "redux-form";
import moment from "moment";
import "./styles.css";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../../shared/components/form/MultiSelect";
import {
  MDBDataTable,
  MDBBtn,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-datepicker";
import MUIDataTable from "mui-datatables";
import "antd/dist/antd.css";
import { TimePicker } from "antd";
import "react-datepicker/dist/react-datepicker.css";
import {
  createMuiTheme,
  MuiThemeProvider,
  withStyles,
} from "@material-ui/core/styles";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { faPlus, faMinus, faPen } from "@fortawesome/free-solid-svg-icons";
import LoadingOverlay from 'react-loading-overlay';

var url = window.location.hostname;
var port = window.location.port;

const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";

class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    onCancel: false,
    task_id: "",
    clickedRow: {},
    updatedClickedRow: {},
    confirmed_data: {},
    picked_qty_exceed_alert: false,
    disableReasonDropdown: true,
    allSelectedReason: {},
    EditModal: false,
    disabledBtn: true,
    cancelDisabledBtn: true,
    selected: {},
    selected_all: false,

    showFetchGRNData: true,
    showConfirmLoader: false,
    loadingupdatebtn: false,
    disabledBtnConfirm: false,
    pickingHistoryId: "0",
    rows: [],

    loadingbtn: false,
    alertMessage: "",
    messageModal: false,
    ErrorMessagemodal: false,
    postsGRN: [],
    postsProduct: [],
    tableRowsGRN: [],
    tableRowsGRN_2: [],
    tableRowsGRNTester: [],
    ErrorRowData: [],
    options: [],
    newArrayData: [],
    selectedUser: {},
    showDateError: {},
    modal: false,
    Confirmmodal: false,
    Successmodal: false,
	loading_overlay: false,
  };

  validateEditForm = (rowId) => {
    let allSelectedReason = {...this.state.allSelectedReason};
    //allSelectedReason[this.state.clickedRow["id"]] = 0;

    this.setState({ picked_qty_exceed_alert: false });
    this.setState({ disableReasonDropdown: true });
    this.setState({ allSelectedReason: allSelectedReason });

    var updated_picked_loose_qty = this.state.updatedClickedRow[rowId]["picked_loose_qty"];
    var updated_picked_icld_qty = this.state.updatedClickedRow[rowId]["picked_icld_qty"];
    if (
      this.state.updatedClickedRow[rowId]["picked_loose_qty"] === "" ||
      this.state.updatedClickedRow[rowId]["picked_loose_qty"] === undefined
    ) {
      updated_picked_loose_qty = 0;
    }

    if (
      this.state.updatedClickedRow[rowId]["picked_icld_qty"] === "" ||
      this.state.updatedClickedRow[rowId]["picked_icld_qty"] === undefined
    ) {
      this.setState({
        updated_picked_icld_qty: 0,
      });
    }

    var total_quantity =
      parseInt(updated_picked_icld_qty) *
        parseInt(this.state.clickedRow["upc"]) +
      parseInt(updated_picked_loose_qty);
    if (
      parseInt(total_quantity) > parseInt(this.state.clickedRow["to_be_picked_qty"])
    ) {
      this.setState({ picked_qty_exceed_alert: true });
      return false;
    } else {
      this.setState({ picked_qty_exceed_alert: false });
    }

    if (
      parseInt(total_quantity) < parseInt(this.state.clickedRow["to_be_picked_qty"])
    ) {
      this.setState({ disableReasonDropdown: false });
      return false;
    } else {
      this.setState({ disableReasonDropdown: true });
    }
  };

  pickedICLDQtyChangedHandler = (e,rowId) => {
	let updatedClickedRow = {...this.state.updatedClickedRow};
    updatedClickedRow[rowId]["picked_icld_qty"] = e.target.value;

    this.setState({ updatedClickedRow: updatedClickedRow }, () => {
      this.validateEditForm(rowId)
    });
  };

  pickedLOOSEQtyChangedHandler = (e,rowId) => {
    let updatedClickedRow = {...this.state.updatedClickedRow};
    updatedClickedRow[rowId]["picked_loose_qty"] = e.target.value;

    this.setState({ updatedClickedRow: updatedClickedRow }, () => {
      this.validateEditForm(rowId);
    });
  };

  reasonCodeHandler = (e) => {
    let allSelectedReason = { ...this.state.allSelectedReason };
    allSelectedReason[this.state.clickedRow["id"]] = e.target.value;

    this.setState({
      allSelectedReason: allSelectedReason,
    });
  };

  confirmUpdateHandler = () => {
    this.validateEditForm(this.state.clickedRow["id"]);
    
	if(this.state.picked_qty_exceed_alert === true){
		return false
	}
    let updated_confirm_data = { ...this.state.confirmed_data };
    let updatedClickedRow = {...this.state.updatedClickedRow};
    let tableRowsGRN = [...this.state.tableRowsGRN];
    
    if (
      this.state.disableReasonDropdown === false &&
      (this.state.allSelectedReason[this.state.clickedRow["id"]] == "" ||
        this.state.allSelectedReason[this.state.clickedRow["id"]] == undefined)
    ) {
      this.setState({ validateReasonCode: true });
      return false;
    } else {
      this.setState({ validateReasonCode: false });
    }

    if (
      this.state.allSelectedReason[this.state.clickedRow["id"]] == undefined ||
      this.state.allSelectedReason[this.state.clickedRow["id"]] == ""
    ) {
      this.state.allSelectedReason[this.state.clickedRow["id"]] = 0;
    }

    var total_quantity =
      parseInt(updatedClickedRow[this.state.clickedRow["id"]]["picked_icld_qty"]) *
        parseInt(updatedClickedRow[this.state.clickedRow["id"]]["upc"]) +
      parseInt(updatedClickedRow[this.state.clickedRow["id"]]["picked_loose_qty"]);

    updated_confirm_data[this.state.clickedRow["id"]] = {
      location: this.state.selectedLocation,
      task_id: this.state.clickedRow["id"],
      picked_qty: total_quantity,
      reason_code_id: this.state.allSelectedReason[this.state.clickedRow["id"]],
    };

    localStorage.setItem("allSelectedReason",JSON.stringify(this.state.allSelectedReason));

    const payload = {
    	location: this.state.selectedLocation,
			task_id: this.state.clickedRow["id"],
			picked_qty: total_quantity,
			reason_code_id: this.state.allSelectedReason[this.state.clickedRow["id"]],
  };

API.post('/maintenance/editBinConsolidationTask/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
		if(data.status === true){
			this.setState({
				EditModal: false,
			}, () => {
			    this.fetchGRNData();
			});
		}
	  })
      .catch(function (error) {});

    /*this.state.tableRowsGRN_2.map((data,index) => {
        console.log(this.state.tableRowsGRN_2);
		console.log(index);
		if(parseInt(this.state.tableRowsGRN_2[index]["id"]) === parseInt(this.state.clickedRow["id"])){
			tableRowsGRN[index]["picked_qty"] = total_quantity;
            tableRowsGRN[index]["picked_icld_qty"] = this.state.updatedClickedRow[this.state.clickedRow["id"]]["picked_icld_qty"];
            tableRowsGRN[index]["picked_loose_qty"] = this.state.updatedClickedRow[this.state.clickedRow["id"]]["picked_loose_qty"];
		}
	});
    
    this.setState({ confirmed_data: updated_confirm_data, EditModal: false,tableRowsGRN: tableRowsGRN });
    localStorage.setItem("tableRowsGRN",JSON.stringify(tableRowsGRN));
    localStorage.setItem("updatedClickedRow",JSON.stringify(updatedClickedRow));
    localStorage.setItem("allSelectedReason",JSON.stringify(this.state.allSelectedReason))*/
  };

  pushConfirmDataToServer = () => {
    let selectedRows = { ...this.state.selected };
    let confirmedData = { ...this.state.confirmed_data };
    let preparedPayload = [];

    Object.keys(selectedRows).map((id) => {
      if (
        this.state.selected[id] === true &&
        Object.keys(confirmedData).indexOf(id.toString()) > -1
      ) {
        preparedPayload.push(confirmedData[id]);
      }
    });

    let batch_id = localStorage.getItem("batch-id");
    this.setState({disabledBtn: true});
    const payload = {
      location: this.state.selectedLocation,
      batch_id: batch_id,
      confirm_tasks: preparedPayload,
  };

API.post('/maintenance/confirmBinConsolidation/v1/', { param: payload })
      .then((response) => {
        this.setState({ Successmodal: true }, () =>{
			localStorage.setItem("tableRowsGRN","");
			localStorage.setItem("updatedClickedRow","");
			localStorage.setItem("allSelectedReason","")
		});
      })
      .catch(function (error) {
		  localStorage.setItem("tableRowsGRN","");
		  localStorage.setItem("updatedClickedRow","");
	      localStorage.setItem("allSelectedReason","")
	  });
  };

  EditToggle = () => this.setState({ EditModal: true });

  togglePressCancel = () => {
    this.setState({
      EditModal: false,
    });
  };

  componentDidMount() {
    if (port == 8091 || port === ":8090") {
      port = ":8090";
    } else if (port == 8098 || port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8090";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie("token");
    var Location = this.getCookie("selectedLocation");
    var username = this.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: Location,
      },
      () => {
		this.fetchGRNData();
      }
    );

    localStorage.setItem("userName", username);
  }

 

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(";");
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  fetchGRNData = () => {
    var checkboxes = document.getElementsByName("select_all_checkbox");

    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked == true) {
        document.getElementsByName(checkboxes[i].name)[0].click();
      }
    }
    var fileNameValue = localStorage.getItem("fileName");

    this.setState({
      columns: [
        {
          label: (
            <input
              type="checkbox"
              name="select_all_checkbox"
              selected={false}
              onChange={this.handleallCheckBoxClick}
            />
          ),
          name: "checkbox",
          width: 100,
        },
        {
          label: "LB SKU ID",
          name: "lb_sku_id",
          width: 100,
        },
        {
          label: "PKD",
          name: "pkd",
          width: 100,
        },
        {
          label: "To be Picked ICLD Qty",
          name: "to_be_picked_icld_qty",
          width: 100,
        },
        {
          label: "Picked ICLD Qty",
          name: "picked_icld_qty",
          width: 100,
        },
        {
          label: "To be Picked LOOSE Qty",
          name: "to_be_picked_loose_qty",
          width: 100,
        },
        {
          label: "Picked LOOSE Qty",
          name: "picked_loose_qty",
          width: 100,
        },
        {
          label: "To be Picked Total Qty",
          name: "to_be_picked_qty",
          width: 100,
        },
        {
          label: "Total Picked Qty",
          name: "picked_qty",
          width: 100,
        },
        {
          label: "From Location",
          name: "from_location",
          width: 100,
        },
        {
          label: "To Location",
          name: "to_location",
          width: 100,
        },
        {
          label: "Action",
          name: "edit",
          width: 100,
        },
      ],
    });
    /*this.setState({
      loading: true,
      postsGRN: [],
      tableRowsGRN: [],
      tableRowsGRNTester: [],
    });*/
    let batch_id = localStorage.getItem("batch-id");
    const payload = {
      location: this.state.selectedLocation,
      batch_id: batch_id,
      request_type: 2,
  };

API.post('/maintenance/fetchBinConsolidationTasks/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
        console.log(data);
        this.setState({ postsGRN: data });

        if (this.state.postsGRN.length > 0) {
          if (this.state.postsGRN[0].pickType === "TESTER") {
            this.setState({
              showFetchGRNData: false,
              showFetchGRNDataTester: true,
            });
          } else {
            this.setState({
              showFetchGRNData: true,
              showFetchGRNDataTester: false,
            });
          }
        } else {
          this.setState({
            showFetchGRNData: true,
            showFetchGRNDataTester: false,
          });
        }
      })

      .then(async () => {
        if (this.state.showFetchGRNData) {
          this.setState({
            tableRowsGRN: this.assemblePostsGRN(),
            isLoading: false,
            loading: false,
            onCancel: false,
          });
        }
      })
      .catch(function (error) {});
  };

  handleCheckBoxClick = (e) => {
    const selected = this.state.selected;
    selected[e.target.name] = e.target.checked;

    this.setState({ selected }, () => {
      let checked = [];
      let selected_checkbox = { ...this.state.selected };

      for (let i = 0; i < Object.keys(this.state.selected).length; i++) {
        if (selected_checkbox[Object.keys(this.state.selected)[i]] == true) {
          checked.push(selected_checkbox[Object.keys(this.state.selected)[i]]);
        }
      }

      if (checked.length > 0) {
        this.setState({
          disabledBtn: false,
          cancelDisabledBtn: false,
        });
      } else {
        this.setState({
          disabledBtn: true,
          cancelDisabledBtn: true,
        });
      }
    });
  };

  handleallCheckBoxClick = (e) => {
    const selected_all = e.target.checked;
    const selected = this.state.selected;

    const checkboxes = document.getElementsByClassName("checkbox_div");
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked != e.target.checked) {
        document.getElementsByName(checkboxes[i].name)[0].click();
      }
    }

    let checked = {};
    let selected_checkbox = { ...this.state.selected };

    for (let i = 0; i < Object.keys(this.state.selected).length; i++) {
      checked[Object.keys(this.state.selected)[i]] = true;
    }

    this.setState({
      selected: checked,
    });

    this.setState({
      selected_all: selected_all,
    });
  };

  setTaskID = () => {
    this.setState({
      onCancel: !this.state.onCancel,
    });
  };

  onCancel = () => {
    this.setState({
      onCancel: !this.state.onCancel,
    });
  };

  taskCancelHandler = () => {
	this.setState({
	  loading_overlay: true
    })  
    let task_ids_for_cancel = [];
    let selected_checkbox = { ...this.state.selected };

    for (let i = 0; i < Object.keys(this.state.selected).length; i++) {
      if (selected_checkbox[Object.keys(this.state.selected)[i]] == true) {
        task_ids_for_cancel.push(Object.keys(this.state.selected)[i]);
      }
    }
    let batch_id = localStorage.getItem("batch-id");
    const payload = {
      location: this.state.selectedLocation,
      task_ids: task_ids_for_cancel,
      batch_id: batch_id,
      cancel_type: 1,
  };

API.post('/maintenance/cancelBinConsolidation/v1/', { param: payload })
      .then((response) => response.data)
      .then((data) => {
		this.setState({
		  loading_overlay: false
		})   
        this.fetchGRNData();
      })
      .catch(function (error) {});
  };

  assemblePostsGRN = () => {
    let data = [];
    let table_row = {};
    let table_row_2 = [];
    let checkbox_html = "";
    let checkbox_classname = "";

    let items = this.state.postsGRN.sort(function (a, b) {
      let textA = a.pkd;
      let textB = b.pkd;
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    
    let prepare_confirm_data = {};
    let checked_flag_arr = {};
    let updatedClickedRow = { ...this.state.updatedClickedRow };
    console.log(items);
    for (let i = 0; i < items.length; i++) {
      
      updatedClickedRow[items[i]["id"]] = items[i];
      let firstobj = items[i]["id"];
      let checkbox_enabled_arr = [];
      checked_flag_arr[firstobj] = false;

      checkbox_classname = "checkbox_div checkbox_" + firstobj;

      checkbox_html = (
        <input
          type="checkbox"
          className={checkbox_classname}
          name={firstobj}
          selected={this.state.selected[checkbox_classname]}
          onChange={this.handleCheckBoxClick}
          style={{ opacity: "0.85" }}
        />
      );
      
      if(localStorage.getItem("tableRowsGRN") !== null && localStorage.getItem("tableRowsGRN") !== "" && localStorage.getItem("tableRowsGRN") !== undefined){
		let tableRowsGRN = JSON.parse(localStorage.getItem("tableRowsGRN"));
		items[i]["picked_qty"] = tableRowsGRN[i]["picked_qty"];
        items[i]["picked_icld_qty"] = tableRowsGRN[i]["picked_icld_qty"];
        items[i]["picked_loose_qty"] = tableRowsGRN[i]["picked_loose_qty"];
	  }
      table_row = {
        checkbox: checkbox_html,
        lb_sku_id: items[i]["lb_sku_id"],
        pkd: items[i]["pkd"],
        to_be_picked_icld_qty: items[i]["to_be_picked_icld_qty"],
        picked_icld_qty: items[i]["picked_icld_qty"],
        to_be_picked_loose_qty: items[i]["to_be_picked_loose_qty"],
        picked_loose_qty: items[i]["picked_loose_qty"],
        to_be_picked_qty: items[i]["to_be_picked_qty"],
        picked_qty: items[i]["picked_qty"],
        from_location: items[i]["from_location"],
        to_location: items[i]["to_location"],
        edit: (
          <a
            style={{ color: "rgb(112, 187, 253)" }}
            onClick={() => this.btnClick(items[i])}
          >
            Edit
          </a>
        ),
      };

       table_row_2.push({
        checkbox: checkbox_html,
        lb_sku_id: items[i]["lb_sku_id"],
        id: items[i]["id"],
        pkd: items[i]["pkd"],
        to_be_picked_icld_qty: items[i]["to_be_picked_icld_qty"],
        picked_icld_qty: items[i]["picked_icld_qty"],
        to_be_picked_loose_qty: items[i]["to_be_picked_loose_qty"],
        picked_loose_qty: items[i]["picked_loose_qty"],
        to_be_picked_qty: items[i]["to_be_picked_qty"],
        picked_qty: items[i]["picked_qty"],
        from_location: items[i]["from_location"],
        to_location: items[i]["to_location"],
        edit: (
          <a
            style={{ color: "rgb(112, 187, 253)" }}
            onClick={() => this.btnClick(items[i])}
          >
            Edit
          </a>
        ),
      });

      prepare_confirm_data[items[i]["id"]] = {
        id: items[i]["id"],
        picked_qty: items[i]["picked_qty"],
        reason_code_id: "",
      };
      data.push(table_row);
    }

    this.setState({
      confirmed_data: prepare_confirm_data,
      selected: checked_flag_arr,
      updatedClickedRow: updatedClickedRow,
      tableRowsGRN_2: table_row_2
    });

	if(localStorage.getItem("updatedClickedRow") !== null && localStorage.getItem("updatedClickedRow") !== "" && localStorage.getItem("updatedClickedRow") !== undefined){
		let updatedClickedRow = JSON.parse(localStorage.getItem("updatedClickedRow"));
		this.setState({
			updatedClickedRow: updatedClickedRow
		});
	}
    
	if(localStorage.getItem("allSelectedReason") !== null && localStorage.getItem("allSelectedReason") !== "" && localStorage.getItem("allSelectedReason") !== undefined){
		let allSelectedReason = JSON.parse(localStorage.getItem("allSelectedReason"));
        
		this.setState({
			allSelectedReason: allSelectedReason
		});
	}
    
    return data;
  };

  btnClick = async (rowData) => {
    let reason_code = { ...this.state.reason_code };

    await this.setState({
      picked_qty_exceed_alert: false,
      disableReasonDropdown: true,
      EditModal: true,
      clickedRow: rowData,
    },async () => {
		await this.validateEditForm(rowData["id"]);
	});
  };

  SuccessToggle = () => {
    this.setState({
      Successmodal: !this.state.Successmodal,
    });
  };

  CancelSuccessToggle = () => {
    this.setState(
      {
        Successmodal: !this.state.Successmodal,
      },
      () => {
        window.location.reload();
      }
    );
  };
  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { modal } = this.state;
    const { Errormodal } = this.state;
    const { Successmodal } = this.state;
    const { Confirmmodal } = this.state;
    const { modalbeforeConfirm } = this.state;
    const { EditModal } = this.state;
    const { ErrorMessagemodal } = this.state;
    const { newArrayData, selectedUser } = this.state;
    var crate_index = -1;

    const uniqueZoneData = {};

    const GRNData = {
      columns: this.state.columns,
      rows: this.state.tableRowsGRN,
    };

	var reasonCodeMsg = "";
    if(this.state.allSelectedReason[this.state.clickedRow["id"]] !== undefined){
		if(this.state.allSelectedReason[this.state.clickedRow["id"]] === "103"){
			reasonCodeMsg = "Perform Cycle Count for the Bin";
        }else if(this.state.allSelectedReason[this.state.clickedRow["id"]] === "102"){
			reasonCodeMsg = "Move damaged physical stock to damage zone";
        }else if(this.state.allSelectedReason[this.state.clickedRow["id"]] === "101"){
			reasonCodeMsg = "The system will register this as missing ";
        }else if(this.state.allSelectedReason[this.state.clickedRow["id"]] === "104"){
			reasonCodeMsg = "Move the inventory back to the Original Source Bin";
        }
	}

    return (
      <Col xl={12}>
	  {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' /> }
        <Card>
          {this.state.showFetchGRNData && (
            <CardBody style={{ marginTop: 20 }}>
              <div className="table_header" style={{ border: "0px" }}>
                <button
                  color="primary"
                  className="btn btn-primary btn-sm pull-left"
                  disabled={this.state.disabledBtn}
                  style={{fontWeight:'normal',textTransform:'capitalize',borderRadius: 5, backgroundColor:'#70bbfd', color:'#fff',padding: "5px 25px",fontSize: "14px"}}
                  onClick={this.pushConfirmDataToServer}
                  type="submit"
                >
                  Confirm
                </button>

                <button
                  color="primary"
                  className="btn btn-primary btn-sm pull-left"
                  disabled={this.state.cancelDisabledBtn}
                  style={{fontWeight:'normal',textTransform:'capitalize',borderRadius: 5, backgroundColor:'#70bbfd', color:'#fff',padding: "5px 25px",fontSize: "14px",marginLeft:'15px'}}
                  onClick={this.setTaskID}
                  type="submit"
                >
                  Cancel
                </button>
				
              </div>
			  <div className="clearfix"></div>
			  
			  <div className="notes" style={{paddingTop:'0px'}}>		
              <p style={{marginBottom: '13px',fontSize: '15px'}}><b>Note</b> : Please verify the Picked ICLD Qty and Picked LOOSE Qty before confirmation.</p>
			 </div>
              <div style={{ marginTop: "0px" }}>
                <MDBDataTable
                  striped
                  bordered
                  hover
                  data={GRNData}
                  scrollX={true}
                />
              </div>
            </CardBody>
          )}
        </Card>

        <Modal
          isOpen={modal}
          toggle={this.toggle}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Split Quantity
            </h4>
          </div>
          <div className="modal__body" style={{ marginTop: 10, padding: 16 }}>
            <div style={{ width: "100%" }}>
              <div style={{ width: "30%", float: "left", textAlign: "left" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> LB SKU ID: </span>{" "}
                  <span> {this.state.lbskuid_val} </span>{" "}
                </span>
              </div>

              <div style={{ width: "22%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> ICLD Qty: </span>{" "}
                  <span> {this.state.defaultquantity} </span>{" "}
                </span>
              </div>

              <div style={{ width: "22%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> PKD: </span>{" "}
                  <span> {this.state.pkd_val} </span>{" "}
                </span>
              </div>

              <div style={{ width: "25%", float: "left", textAlign: "right" }}>
                <span style={{ fontSize: 15 }}>
                  <span style={{ fontWeight: "bold" }}> MRP: </span>{" "}
                  <span> {this.state.mrp_val} </span>{" "}
                </span>
              </div>
            </div>

            <table className="table table-bordered" id="tab_logic">
              <thead style={{ textAlign: "left" }}>
                <tr>
                  <th>BIN</th>
                  <th>QTY</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ textAlign: "left" }}>
                    <div className="search-container">
                      <div className="react-search-field test-class">
                        <input
                          className="react-search-field-input"
                          placeholder="Search for Bearing No."
                          type="text"
                          style={{ padding: 4, borderRadius: 2 }}
                          defaultValue={this.state.typeaheadText}
                          value={this.state.typeaheadText}
                          onChange={this.showTypeahead}
                        />
                      </div>

                      {this.state.showTypeahead && (
                        <div
                          className="suggestions-container"
                          ref={(el) => (this.typeahead = el)}
                        >
                          {this.state.zwz_search_pannel && (
                            <div
                              className="suggestions"
                              onClick={this.closeContainer}
                            >
                              {this.state.data.length > 0 &&
                                this.state.data.map((item, index) => (
                                  <p
                                    key={index}
                                    onClick={() =>
                                      this.setBinId(item.binAddress)
                                    }
                                    className="typeahead-text"
                                  >
                                    {item.binAddress}{" "}
                                  </p>
                                ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </td>
                  <td style={{ textAlign: "left" }}>
                    <input
                      type="text"
                      value={this.state.quantity}
                      onChange={this.showTypeaheadChange}
                      style={{ padding: 4, borderRadius: 2 }}
                    />
                    <i
                      onClick={this.handleAddRow}
                      class="fa fa-plus-circle"
                      style={{
                        marginLeft: 15,
                        fontSize: 17,
                        cursor: "pointer",
                      }}
                    ></i>
                    <i
                      onClick={this.handleRemoveRow}
                      class="fa fa-minus-circle"
                      aria-hidden="true"
                      style={{
                        marginLeft: 15,
                        fontSize: 17,
                        cursor: "pointer",
                      }}
                    ></i>
                  </td>
                </tr>

                {this.state.rows.map((row, index) => (
                  <tr>
                    <td style={{ textAlign: "left" }}>
                      <div className="search-container">
                        <div className="react-search-field test-class">
                          <input
                            className="react-search-field-input"
                            placeholder="Search for Bin Address"
                            type="text"
                            style={{ padding: 4, borderRadius: 2 }}
                            value={row.binId}
                            onChange={(e) =>
                              this.onBinChange1(index, e.target.value)
                            }
                          />
                        </div>

                        {this.state.showContainer[index] && (
                          <div
                            className="suggestions-container"
                            ref={(el) => (this.typeahead = el)}
                          >
                            <div
                              className="suggestions"
                              onClick={this.closeContainer}
                            >
                              {this.state.data.length > 0 &&
                                this.state.data.map((item, i) => (
                                  <p
                                    key={i}
                                    onClick={() =>
                                      this.setBinIdLoop(index, item.binAddress)
                                    }
                                    className="typeahead-text"
                                  >
                                    {item.binAddress}{" "}
                                  </p>
                                ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </td>
                    <td style={{ textAlign: "left" }}>
                      <input
                        type="text"
                        onChange={(e) =>
                          this.onQuantityChange1(index, e.target.value)
                        }
                        style={{ padding: 4, borderRadius: 2 }}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <ButtonToolbar className="modal__footer">
              <button
                  className="modal_cancel"
                onClick={this.togglePressCancel}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.processData}
              >
                Submit
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={modalbeforeConfirm}
          toggle={this.beforeConfirm}
          style={{ maxWidth: 700, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Confirmation
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 14 }}>
            <Table
              responsive
              className="table--bordered"
              style={{ marginBottom: 75 }}
            >
              <thead>
                <tr>
                  <th>User Id</th>
                  <th>User Name</th>
                  <th>Select Date</th>
                  <th>Select Time</th>
                </tr>
              </thead>

              <tbody>
                {Object.keys(uniqueZoneData).length > 0 &&
                  _.map(uniqueZoneData, (item, key) => (
                    <tr key={key}>
                      <td>{item.zoneId}</td>
                      <td>{item.zoneName} </td>
                      <td>
                        <DatePicker
                          dateFormat="MM/dd/yyyy"
                          selected={item.date}
                          onChange={(date) =>
                            this.handleChangeDate(item.zoneName, date)
                          }
                        />

                        {this.state.showDateError[item] && (
                          <span> Please Select Date </span>
                        )}
                      </td>

                      <td>
                        <TimePicker
                          format="HH:mm"
                          onChange={(time) =>
                            this.handleChangeTime(item.zoneName, time)
                          }
                        />{" "}
                        <br />
                        {item.error && (
                          <span style={{ color: "red" }}>{item.error}</span>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            {this.state.isEmptyCrateArr && (
              <span style={{ color: "red" }}>
                Please fill Crate detail for all lines
              </span>
            )}

            <ButtonToolbar className="modal__footer">
              <button
                  className="modal_cancel"
                onClick={this.CancelBeforeModal}
              >
                Cancel
              </button>
              <Button
                disabled={this.state.disabledBtnConfirm}
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                }}
                className="modal_ok"
                onClick={this.ConfirmPutAway}
              >
                {this.state.showConfirmLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Confirm
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal
          isOpen={EditModal}
          toggle={this.EditToggle}
          style={{ maxWidth: 500, height: 500, padding: 0 }}
        >
          <div className="modal__header" style={{ backgroundColor: "#70bbfd" }}>
            <h4
              className="text-modal  modal__title"
              style={{ color: "#fff", paddingTop: 10 }}
            >
              Edit Entry
            </h4>
          </div>
          <div className="modal__body" style={{ padding: 12 }}>
            <div style={{ width: "100%" }}>
              <div className="row">
                <div
                  className="col-xl-6"
                  style={{ display: "inline", marginBottom: "15px" }}
                >
                  <div
                    style={{
                      textAlign: "left",
                      marginLeft: "21px",
                    }}
                  >
                    <span style={{ fontSize: 15 }}>
                      <span style={{ fontWeight: "bold" }}> LB SKU ID : </span>{" "}
                      <span>{this.state.clickedRow["lb_sku_id"]}</span>
                    </span>
                  </div>
                </div>

                <div
                  className="col-xl-6"
                  style={{ display: "inline", marginBottom: "15px" }}
                >
                  <div style={{ width: "100%", textAlign: "left" }}>
				  <span style={{ fontSize: 15 }}>
                      <span style={{ fontWeight: "bold" }}> Pkd : </span>{" "}
                      <span>{this.state.clickedRow["pkd"]}</span>{" "}
                    </span>
					
                    
                  </div>
                </div>
              </div>
            </div>

            <div style={{ width: "100%" }}>
              <div className="row">
                <div className="col-xl-6" style={{ display: "inline" }}>
                  <div
                    style={{
                      width: "100%",
                      textAlign: "left",
                      marginLeft: "21px",
                    }}
                  >
				  <span style={{ fontSize: 15 }}>
                      <span style={{ fontWeight: "bold" }}> From Bin : </span>{" "}
                      <span>{this.state.clickedRow["from_location"]}</span>{" "}
                    </span>
                    
                  </div>
                </div>

                <div className="col-xl-6" style={{ display: "inline" }}>
                  <div style={{ width: "100%", textAlign: "left" }}>
                    <span style={{ fontSize: 15 }}>
                      <span style={{ fontWeight: "bold" }}> To Bin : </span>{" "}
                      <span>{this.state.clickedRow["to_location"]}</span>{" "}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <Table
              responsive
              className="table"
              style={{ marginBottom: 0, marginTop: 12, border: "0px" }}
            >
              <tbody>
                <tr key={this.state.clickedRow["id"]}>
                  <td style={{ textAlign: "left", paddingLeft: "17px" }}>
                    Picked Qty (ICLD)
                  </td>
                  <td style={{ textAlign: "left", paddingLeft: "15px" }}>
                    Picked Qty (Loose)
                  </td>
                </tr>
                <tr>
                  <td style={{ textAlign: "left", paddingLeft: "17px" }}>
                    <input
                      type="text"
                      defaultValue={
                        this.state.clickedRow["id"] !== undefined ? this.state.updatedClickedRow[this.state.clickedRow["id"]] ===
                        undefined
                          ? this.state.clickedRow["picked_icld_qty"]
                          : this.state.updatedClickedRow[this.state.clickedRow["id"]][
                              "picked_icld_qty"
                            ] : 0
                      }
                      onChange={(e) => {this.pickedICLDQtyChangedHandler(e,this.state.clickedRow["id"])}}
                      style={{
                        padding: 4,
                        borderRadius: 2,
                        marginLeft: "0px",
                        width: "50%",
                        borderColor: "#dddddd",
                        borderWidth: "1px",
                        borderStyle: "solid",
                      }}
                    />
                  </td>

                  <td style={{ textAlign: "left", paddingLeft: "15px" }}>
                    <input
                      type="text"
                      defaultValue={
                        this.state.clickedRow["id"] !== undefined ? this.state.updatedClickedRow[this.state.clickedRow["id"]] ===
                        undefined
                          ? this.state.clickedRow["picked_loose_qty"]
                          : this.state.updatedClickedRow[this.state.clickedRow["id"]][
                              "picked_loose_qty"
                            ]: 0
                      }
                      onChange={(e) => {this.pickedLOOSEQtyChangedHandler(e,this.state.clickedRow["id"])}}
                      style={{
                        padding: 4,
                        borderRadius: 2,
                        width: "50%",
                        borderColor: "#dddddd",
                        borderWidth: "1px",
                        borderStyle: "solid",
                      }}
                    />
                    <br />
                    {this.state.picked_qty_exceed_alert && (
                      <span style={{ fontSize: 11, color: "red" }}>
                        {" "}
                        Pick Loose quantity exceeds actual quantity{" "}
                      </span>
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>

            <Table
              responsive
              className="table"
              style={{ marginBottom: 0, marginTop: 12, border: "0px" }}
            >
              <tr key="reason_code">
                <td
                  style={{
                    border: "0px",
                    textAlign: "left",
                    paddingLeft: "22px",
                    width: "35%",
                  }}
                >
                  Select Reason Code
                </td>
                <td style={{ border: "0px", textAlign: "left", width: "100%" }}>
                  <select
                    onChange={this.reasonCodeHandler}
                    style={{ padding: 4, borderRadius: 2, width: "50%" }}
                    disabled={this.state.disableReasonDropdown}
                    defaultValue={
                      this.state.allSelectedReason[
                        this.state.clickedRow["id"]
                      ] != undefined
                        ? this.state.allSelectedReason[
                            this.state.clickedRow["id"].toString()
                          ].toString()
                        : ""
                    }
                  >
                    <option value="">Select Reason</option>
                    <option value="103">Other Product</option>
					<option value="102">Damaged</option>
					<option value="101">Unavailable</option>
					<option value="104">No space</option>
                  </select>
                  
                  {this.state.validateReasonCode && (
                    <span
                      style={{
                        fontSize: 11,
                        color: "red",
                        paddingLeft: "10px",
                      }}
                    >
                      Select reason code
                    </span>
                  )}
                </td>
              </tr>
            </Table>
			{reasonCodeMsg !== "" &&
			<p style={{textAlign: "left",paddingLeft: "22px"}}>Note : {reasonCodeMsg}</p>
			}
            <ButtonToolbar className="modal__footer">
              <button
                  className="modal_cancel"
                onClick={this.togglePressCancel}
              >
                Cancel
              </button>
              <Button
                style={{
                  backgroundColor: "#24d6a3",
                  color: "#fff",
                  marginLeft: 12,
                  backgroundColor: "#3ea3fc",
                }}
                className="modal_ok"
                onClick={this.confirmUpdateHandler}
              >
                {this.state.showUpdateLoader && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                Update
              </Button>
            </ButtonToolbar>
          </div>
        </Modal>

        <Modal isOpen={Errormodal} toggle={this.Errortoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Errortoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>{this.state.ErrorMessage} </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.Errortoggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Successmodal} toggle={this.Successtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Successtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-checkmark-circle modal__title-icon"
              style={{ color: "green" }}
            />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.CancelSuccessToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Confirmmodal} toggle={this.Confirmtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Confirmtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-checkmark-circle modal__title-icon"
              style={{ color: "green" }}
            />
            <h4>Successfully Updated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.CancelConfirmToggle}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={this.state.onCancel} toggle={this.state.onCancel}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.onCancel}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />

            <h4> Are you sure you want to cancel ? </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <button
              style={{ marginRight: 8 }}
              className="modal_cancel"
              onClick={this.onCancel}
            >
              Cancel
            </button>
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.taskCancelHandler}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>
      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master",
})(withTranslation("common")(HorizontalForm));